import script from "./imageLabelGallery.component.vue?vue&type=script&lang=ts&setup=true"
export * from "./imageLabelGallery.component.vue?vue&type=script&lang=ts&setup=true"

import "./imageLabelGallery.component.vue?vue&type=style&index=0&id=24ef15c5&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/WEAS/WEAS_CI/WEAS_FRONT/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24ef15c5"]])

export default __exports__